import { useTranslation } from 'react-i18next';
import globalStyles from '../../styles/globalStyles.module.css';

const NotFound: React.FC = () => {
    const { t } = useTranslation();
  
return(
  <div>

    <div className={globalStyles.pageTitle}>
        {t("notFound")}
    </div>
    <div>
      {t("notFoundDescription")}
    </div>
  </div>
    );
  };

export default NotFound;